<template>
  <section id="other-projects">
    <h2>Other Noteworthy Projects</h2>
    <router-link
      to="/projects"
      class="inline-link archive-link"
    >view the archive</router-link>

    <div class="projects-grid">
      <div
        v-for="project in projects"
        :key="project.name"
        class="projects-standalone"
      >
        <div class="project-inner">
          <header>
            <div class="project-top">
              <div class="folder">
                <font-awesome-icon icon="folder-plus" />
              </div>
              <div class="project-links">
                <a
                  v-if="project.githubLink === '#'"
                  href="javascript:void(0)"
                  aria-label="Github Link"
                >
                  <font-awesome-icon
                    :icon="['fab', 'github',]"
                    role="presentation" />
                </a>
                <a
                  v-else
                  :href="project.githubLink"
                  aria-label="Github Link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <font-awesome-icon
                    :icon="['fab', 'github',]"
                    role="presentation" />
                </a>
                <a
                  :href="project.liveLink"
                  aria-label="Live Site Link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <font-awesome-icon icon="link" />
                </a>
              </div>
            </div>
            <h3 class="project-title">{{ project.name }}</h3>
            <div class="project-description">
              <p>
                {{ project.description | truncate(90, '...') }}
              </p>
            </div>
          </header>
          <footer>
            <ul class="project-tech-list">
              <li
                v-for="tech in project.techList"
                :key="project.name+'-'+tech">
                {{ tech }}
              </li>
            </ul>
          </footer>
        </div>
      </div>
    </div>
    <button
      v-if="showMoreButton"
      class="more-button"
      role="button"
      @click="addMoreProjects"
    >
      Show More
    </button>
  </section>
</template>

<script>
export default {
  name: 'AllProjects',
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    }
  },
  data () {
    return {
      projects: [
        {
          name: 'Lilly Corporate',
          description: 'Medicines, Science, News & More | Eli Lilly and Company',
          githubLink: '#',
          liveLink: 'https://www.lilly.com/',
          techList: [
            'Vue JS', 'NUXT', 'Koa'
          ]
        },
        {
          name: 'Lilly Design',
          description: 'A library consisting of 200+ rich, beautiful and accessible vue components that has been used in all sites',
          githubLink: '#',
          liveLink: '#',
          techList: [
            'Vue', 'NUXT', 'Heroku'
          ]
        },
        {
          name: 'Trulicity US',
          description: 'Type 2 Diabetes & Cardiovascular Disease Treatment | Trulicity (dulaglutide) Once Weekly Injection',
          githubLink: '#',
          liveLink: 'https://www.trulicity.com/',
          techList: [
            'Vue', 'NUXT', 'Heroku'
          ]
        },
        {
          name: 'Lilly Diabetes',
          description: 'Type 2 Diabetes & Cardiovascular Disease Treatment | Trulicity (dulaglutide) Once Weekly Injection',
          githubLink: '#',
          liveLink: 'https://www.lillydiabetes.com/',
          techList: [
            'Vue', 'NUXT', 'Heroku'
          ]
        },
        {
          name: 'Levi Ecomm',
          description: 'Levi Strauss & Co. is an American clothing company known worldwide for its Levi\'s brand of denim jeans.',
          githubLink: '#',
          liveLink: 'https://www.levi.com/US/en_US',
          techList: [
            'Hybris', 'Hybris UI', 'JQuery', 'Vue'
          ]
        },
        {
          name: 'Levi Store',
          description: 'An hybrid mobile app for barcode scanning and inventory tracking',
          githubLink: '#',
          liveLink: '#',
          techList: [
            'JQuery', 'Backbone', 'Underscore'
          ]
        }
      ],
      moreProjects: [
        {
          name: 'Gintaa v2',
          description: 'Draft version 2 of Gintaa development and design',
          githubLink: '#',
          liveLink: 'https://www.gintaa.com',
          techList: [
            'Angular v8', 'SSR', 'Firebase'
          ]
        },
        {
          name: 'Gintaa v1',
          description: 'Draft version 1 of Gintaa development and design',
          githubLink: '#',
          liveLink: 'https://www.gintaa.com',
          techList: [
            'Angular v6', 'SSR', 'Firebase'
          ]
        },
        {
          name: 'Go Russia',
          description: 'Book tours, activities and attractions with gorussia',
          githubLink: '#',
          liveLink: 'https://gorussia.today',
          techList: [
            'Laravel', 'JQuery', 'Bootstrap'
          ]
        },
        {
          name: 'GM Jewellers',
          description: 'GM Jewellers is a producer of exclusive high-quality diamond and Gemstones jewellery.',
          githubLink: '#',
          liveLink: 'http://www.gmjeweller.com/',
          techList: [
            'PHP', 'MySQL', 'JQuery'
          ]
        },
        {
          name: 'ASKOT Foundation',
          description: 'ASKOT foundation is a non profit group helps on preserving himalayan culture',
          githubLink: '#',
          liveLink: 'https://www.askot.org',
          techList: [
            'React', 'JQuery', 'Bootstrap', 'SCSS'
          ]
        },
        {
          name: 'TRANSMEDCON',
          description: 'Annual Conference of the Indian Society of Transfusion Medicine',
          githubLink: '#',
          liveLink: 'https://ruedakolkata.com/',
          techList: [
            'PHP', 'JQuery', 'MySQL', 'Bootstrap'
          ]
        },
        {
          name: 'OSWB',
          description: 'Annual Conference of the Ophthalmological Society of West Bengal',
          githubLink: '#',
          liveLink: 'https://ruedakolkata.com/',
          techList: [
            'PHP', 'JQuery', 'MySQL', 'Bootstrap'
          ]
        },
        {
          name: 'AIOS',
          description: 'Annual Conference of the All India Ophthalmological Society',
          githubLink: '#',
          liveLink: 'https://ruedakolkata.com/',
          techList: [
            'PHP', 'JQuery', 'MySQL', 'Bootstrap'
          ]
        },
        {
          name: 'All Sports',
          description: 'Tailored Solutions. For Millions of Users Sports. ERP. Technology. Innovation',
          githubLink: '#',
          liveLink: 'https://allsport.in/',
          techList: [
            'Cake PHP', 'JQuery', 'MySQL'
          ]
        }
      ],
      showMoreButton: true
    }
  },
  methods: {
    addMoreProjects () {
      this.projects = [
        ...this.projects,
        ...this.moreProjects
      ]
      this.showMoreButton = false
    }
  }
}
</script>

<style scoped>
</style>
